import Vue from 'vue'
import Vuex from 'vuex'
import cookie from './../js/cookie.js'
import createPersistedState from 'vuex-persistedstate'

Vue.use(Vuex)

import mutations from './mutation'

const store = new Vuex.Store({
  // 内存数据状态，UI可通过this.$store.state.* 获得数据
  state: {
    //登陆token
    token: cookie.readCookie('sitesdktoken') || null,
    //导航栏颜色
    num: -1,
    //用户id
    userid: cookie.readCookie('userid') || null,
    openid: sessionStorage.getItem('openid') || null,
    isPc: window.innerWidth > 768 ? true : false,
    firstInProd: 0,
    refuseAddress: sessionStorage.getItem('refuseAddress') || '',
    provinceid: sessionStorage.getItem('provinceid') || '',
    latitude: sessionStorage.getItem('latitude') || '',
    longitude: sessionStorage.getItem('longitude') || '',
    wxUrl: sessionStorage.getItem('wxUrl') || 'http://wbstzd.ewangke.com',
    agreeAddress: sessionStorage.getItem('agreeAddress') || '',
    type: sessionStorage.getItem('type') || '',
    kt_api_root:'http://www.ewangke.com/api/ac/',
    autoHttp:'http://www.ewangke.com/',
    singIn: {
      openid: ''
    },
    types: -1,//机型，1为ios，0为安卓
    goods:{},//需要兑换的商品
  },
  mutations,
  plugins: [
    createPersistedState({
      storage: {
        getItem: key => sessionStorage.getItem(key),
        setItem: (key, value) => sessionStorage.setItem(key, value),
        removeItem: key => sessionStorage.removeItem(key),
      },
    }),
  ],
  actions: {
    getToken (context) {
      if (!this.state.singIn.openid) {
        let searchObj = {}
        location.search.slice(1).split('&').forEach(item => {
          let itemArr = item.split('=')
          searchObj[itemArr[0]] = itemArr[1]
        })
        context.commit('SAVE_SIGNIN', searchObj)
        context.commit('setOpenid', searchObj.openid)
      }
    },
    judgeType (context) {
      let u = navigator.userAgent
      let ios = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/)
      if (ios) {
        context.commit('SAVE_TYPE', 1)
      } else {
        context.commit('SAVE_TYPE', 0)
      }
    },
  }
})

export default store



// WEBPACK FOOTER //
// ./src/store/index.js